import * as React from 'react';
import { Row, Col, Card } from 'antd';
import classNames from 'classnames';
import './index.less';

export interface IABSAntListItem {
  title: any;
  value: any;
  align?: 'left' | 'center' | 'right';
}
export interface IABSAntListProps {
  list: IABSAntListItem[];
  column: number;
  removeBorder?: boolean;
  removeTitleBorder?: boolean;
}

export default class ABSAntList extends React.Component<IABSAntListProps> {
  static defaultProps = {
    removeBorder: false,
    removeTitleBorder: false,
  };

  calcClass = (index: number) => {
    const { column } = this.props;
    const i = index + 1;
    const className = 'abs-ant-list-column-' + i % column;
    return className;
  }
  renderItem(item: IABSAntListItem, index: number) {
    const { column, removeTitleBorder } = this.props;
    const useCol = 24 % column === 0;
    const className = this.calcClass(index);
    const headBorder = removeTitleBorder ? { borderBottom: 'none'} : {};
    const { align = 'left' } = item; // 默认左对齐
    const noTitlePadding = removeTitleBorder ? {paddingTop: 0} : {};
    const alignStyle = { textAlign: align };
    const headStyle = {...headBorder, ...alignStyle};
    const bodyStyle = {...alignStyle, ...noTitlePadding};
    if (useCol) {
      const spanNum = column > 0 ? 24 / column : 0;
      return(
        <Col span={spanNum}>
          <Card title={item.title} className={className} headStyle={headStyle} bodyStyle={bodyStyle}>
            {item.value}
          </Card>
        </Col>
      );
    } else {
      const width = column > 0 ? 100 / column : 0;
      return(
        <div style={{display: 'inline-block', width: width + '%', alignContent: 'stretch'}}>
          <Card title={item.title} className={className} headStyle={headStyle} bodyStyle={bodyStyle}>
            {item.value}
          </Card>
        </div>
      );
    }
  }
  public render() {
    const { list, removeBorder } = this.props;
    const clazz = classNames('abs-ant-list', { 'no-border-list' : removeBorder});
    return (
      <div className={clazz}>
        <Row>
          {
            list.map((item, index) => (
              this.renderItem(item, index)
            ))
          }
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSAntList/index.tsx